import { ExtraLinksFn } from 'graphql/apolloClient'
import { createOnErrorLink } from 'graphql/link/onError'
import { History } from 'history'
import { useRef } from 'react'

export interface UseExtraApolloLinksProps {
  history: History
}

const createExtraApolloLinks = ({
  history,
}: UseExtraApolloLinksProps): ExtraLinksFn => getClient => [
  createOnErrorLink(getClient, history),
]

export const useExtraApolloLinks = (props: UseExtraApolloLinksProps) => {
  // We want to have a singleton.
  // This should never change even if the parent components get rerendered.
  const extraLinks = useRef(createExtraApolloLinks(props))

  return extraLinks.current
}
